module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA15.dc1e5b31.jpg";